module.exports = __webpack_public_path__ + "media/icons/plus@2x-597b1722.png";